async function updateCartDrawer() {
  const locale = Shopify.locale || document.documentElement.lang || "en";
  const res = await fetch(`/${locale}-en?section_id=c-cart-drawer`);
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}


 
$(document).ready(function () {
  const currentLocale = window.Shopify.locale || document.documentElement.lang || "en";
  console.log('current locale',currentLocale)
 c_slider()
    function c_slider(){
const swiper = new Swiper('.u_cart_upsells_pro_body', {
 slidesPerView: 2.9,
  spaceBetween: 10,
});
  }
    $(document).on('click','.site-nav__link.cart-link',function (e) {
      e.preventDefault();
    $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
    $("html").addClass("u_cart_overflow");
    
    $('.u_cart_upsells_wrapper').show()
  });
    $(document).on('click','.u_drawer_overlay,.u_cart_drawer_close',function () {
    $(".u_cart_drawer_block").removeClass("u_cart_drawer_active");
    $("html").removeClass("u_cart_overflow");
      $('.u_shop_var_mb_overlay').hide()
 $('.u_pro_atc_mb_block').removeClass('u_pro_mb_active')
 $('#shopify-section-header,#shopify-section-announcement').removeClass('u_header_z')
  });
   function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);     
        $('.cart-count').text(result);
      });
    }
    $(document).ready(function(){
      getCartCount();
    });
    
  $(document).on("click", ".u_cart_item_plus", function () {
    console.log("testing");
    let input = $(this).parent().find(".u_qty_number");
    var oldVal = $(this).parent().find(".u_qty_number").val();
    var newVal = parseInt(oldVal) + 1;
    var vid = $(this).attr("data-variantid");
    let cart_count = 0;
    $.getJSON("/cart.js", function (cart) {
      cart_count = parseInt(cart.item_count);
      console.log("cart count before", cart_count);
    });
    let ths = $(this);
    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: {
        quantity: newVal,
        id: vid,
      },
      beforeSend: function () {
        ths.addClass("custom----disabled");
        ths.closest(".u_cart_item_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_item").find(".u_cart_spinner").show();
      },
      success: function (__cart) {
        console.log("ajax request", __cart);
        let check_count = parseInt(__cart.item_count);
        updateCartDrawer();
           getCartCount();
           setTimeout(function(){
           c_slider()
           },1000)
           setTimeout(function(){
            $('.u_cart_upsells_wrapper').show()
           },1200)

        if (cart_count == check_count) {
          console.log(`All quantities are in your cart.`);
        } else {
          updateCartDrawer();
             getCartCount();
                        setTimeout(function(){
           c_slider()
           },700)
        }
      },
      complete: function () {
        setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_item_row").attr("style", "opacity:1");
          ths.closest(".u_cart_item").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });
  $(document).on("click", ".u_cart_item_minus", function () {
    console.log("decrease");
    let input = $(this).parent().find(".u_qty_number");
    let input_val = parseInt(input.val());
    let count = parseInt(input.val()) - 1;
    var vid = $(this).attr("data-variantid");
    let ths = $(this);
    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: {
        quantity: count,
        id: vid,
      },
      beforeSend: function () {
        ths.addClass("custom----disabled");
        ths.closest(".u_cart_item_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_item").find(".u_cart_spinner").show();
      },
      success: function (__cart) {
        updateCartDrawer();
           getCartCount();
            setTimeout(function(){
           c_slider()
           },1000)
            setTimeout(function(){
            $('.u_cart_upsells_wrapper').show()
           },1200)
      },
      complete: function () {
        setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_item_row").attr("style", "opacity:1");
          ths.closest(".u_cart_item").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });
  $(document).on("click", ".u_cart_item_remove svg", function () {
    console.log("remove");
    var vid = $(this).parent().attr("data-variantid");
    let ths = $(this);
    $.ajax({
      url: "/cart/change.js",
      type: "post",
      dataType: "json",
      data: {
        quantity: 0,
        id: vid,
      },
      beforeSend: function () {
        ths.addClass("custom----disabled");
        ths.closest(".u_cart_item_row").attr("style", "opacity:.3");
        ths.closest(".u_cart_item").find(".u_cart_spinner").show();
      },
      success: function (__cart) {
        console.log("cart", __cart);
        updateCartDrawer();
           getCartCount();
            setTimeout(function(){
           c_slider()
           },1000)
            setTimeout(function(){
            $('.u_cart_upsells_wrapper').show()
           },1200)
      },
      complete: function () {
        setTimeout(function () {
          ths.removeClass("custom----disabled");
          ths.closest(".u_cart_item_row").attr("style", "opacity:1");
          ths.closest(".u_cart_item").find(".u_cart_spinner").hide();
        }, 1000);
      },
    });
  });

  $(".btn--add-to-cart").click(function (e) {
    e.stopPropagation();
    e.preventDefault();
    let form_data = $(this).closest("form").serialize();
    console.log("form data", form_data);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form_data,
      dataType: "json",
      beforeSend: function () {
        // setting a timeout
        console.log("before enter");
        // $(".u_animated_cont").show();
        //    $("html").addClass("u_cart_overflow");
      },
      success: function (result) {
        console.log("add to cart");
        updateCartDrawer();
       $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
    // $("html").addClass("u_cart_overflow");
         setTimeout(function(){
        getCartCount();       
        c_slider()            
      }, 1000);
       setTimeout(function(){
            $('.u_cart_upsells_wrapper').show()
           },1200)
      },
      error: function (err) {
        console.log("error", err);
      },
      complete: function () {
        console.log("complete");
      },
    });
  });
  if($(document).width() < 786){
$('.u_dk_var').remove()
$(document).on('click','.u_pro_shop_atc',function(){
  console.log('click')
  let pid = $(this).attr('product-id').trim();
  console.log('pid',pid)
  $('.u_pro_atc_mb_block').each(function(){
     let mbid = $(this).attr('product-id').trim();    
     if(pid == mbid){
      console.log('mbid',mbid)
      $(this).addClass('u_pro_mb_active')
      $('#shopify-section-header,#shopify-section-announcement').addClass('u_header_z')
      $('.u_shop_var_mb_overlay').show()
      $("html").addClass("u_cart_overflow");
     }
  })
})
$(document).on('click','.u_shop_var_mb_overlay,.u_shop_atc_close_btn',function(){
    $('.u_shop_var_mb_overlay').hide()
$("html").removeClass("u_cart_overflow");
$('#shopify-section-header,#shopify-section-announcement').removeClass('u_header_z')
 $('.u_pro_atc_mb_block').removeClass('u_pro_mb_active')
})
  }
    $(document).on('click','.u_pro_shop_var,.u_pro_atc_add',function(e){
       e.stopPropagation();
    e.preventDefault();
    
 var vid = $(this).attr('var-id');
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
    data:{
        quantity: 1, 
        id: vid
},
      dataType: "json",
      beforeSend: function () {
        // setting a timeout
        console.log("before enter");
          //  $("html").addClass("u_cart_overflow");
      },
      success: function (result) {
        console.log("add to cart");
        updateCartDrawer();
       $(".u_cart_drawer_block").addClass("u_cart_drawer_active");
       
    // $("html").addClass("u_cart_overflow");
         setTimeout(function(){
        getCartCount();       
        c_slider()            
      }, 1000);
       setTimeout(function(){
            $('.u_cart_upsells_wrapper').show()
           },1200)
      },
      error: function (err) {
        console.log("error", err);
      },
      complete: function () {
        console.log("complete");
      },
    });
    })
});
